<div [formGroup]="pathologyS.pathologyForm">
    <div class="h100 l-flex-w summary ">
        <section class="m-box" style="width: 100%;min-height: 7em;">
            <h2>Pathology</h2>
            <div style="display: flex;height: 100%;">
                <div style="width:33%;align-self: center;padding-block-start: 1em;" >
                    <label style="margin-right: 0.5em;">Pathology Type</label>
                    <select class="t-select t-field" formControlName="Type">
                        <option></option>
                        <ng-container>
                            <option value="Biopsy">Biopsy</option>
                            <option value="Hot Biopsy">Hot Biopsy</option>
                            <option value="Polypectomy">Polypectomy</option>
                            <option value="Polypectomy + Hot Biopsy">Polypectomy + Hot Biopsy</option>
                        </ng-container>
                    </select>
                </div>
                <div style="width: 27%;display: flex; padding-block-start: 1em;" *ngIf="pathologyS.pathologyForm.get('Type').value">
                    <label style="align-self: center;margin-right: 0.5em;">Barcode:</label>
                     <input #barcodeInput class="fulltext pathText" formControlName="BarCode" type="number" *ngIf="scanning && ! pathologyScanning"/>
                    <span *ngIf="! scanning && pathologyS.pathologyForm.get('BarCode').value" style="align-self: center;">{{pathologyS.pathologyForm.get('BarCode').value}}</span>
                    <button (click)="startScan()" class="btn" style="color: white; padding-left: 1em; padding-right: 1em; margin-left: 1em" *ngIf="! es.isClosed && pathologyS.pathologyForm.get('Type').value && ! scanning">Scan Code</button>
                </div>
                <div style="width: 40%;display: flex;justify-content: space-between;padding-block-start: 1em;" *ngIf="pathologyS.pathologyForm.get('Type').value">
                    <label style="align-self: center;margin-right: 0.5em;">Comments:</label>
                    <section class="l-flex-c t-field commText">
                        <textarea class="fulltext pathText" formControlName="Comments"></textarea>
                    </section>
                    <button class="btn" (click)="pathologyS.save()"><label style="color: white;">Add</label></button>
                </div>
            </div>
            <button class="t-btn-edit" *ngIf="! es.isClosed && pathologyS.pathologyForm.get('Type').value"
            (click)="atS.showAuto(gs.gastroForm.get('Comments'),'Comments',211)">Auto Text</button>
        </section>

        <section class="m-box" style="width: 100%" *ngIf="pathologyS.pathologies && pathologyS.pathologies.length > 0">
            <div class="l-table-auto">
                <div class="l-row weightAss-tbody">
                    <div class="l-td-m" style="width: 5%;"></div>
                    <div class="l-td-m" style="width: 5%;">#</div>
                    <div class="l-td-m" style="width: 15%;">Type</div>
                    <div class="l-td-m" style="width: 15%;">Barcode</div>
                   
                    <div class="l-td-m" style="width: 60%;">Comments</div>
                    
                </div>
                <ng-container *ngFor="let path of pathologyS.pathologies;index as i">
                    <div class="l-row weightAss-tbody">
                        <div class="l-td-m center">
                            <button class="auto-text-delete-button" (click)="pathologyS.delete(path)" *ngIf="! path.Lab && ! path.LabReport && ! es.isClosed">
                                <img src="../../assets/icons/x.svg" style="vertical-align: auto;" width="20" height="20" alt="Delete Icon">
                            </button>
                        </div>
                        <div class="l-td-m">{{i+1}}</div>
                        <div class="l-td-m">{{path.Type}}</div>
                        <div class="l-td-m">
                            {{path.BarCode? path.BarCode: ''}}
                            <input #barcodeInputP class="fulltext pathText" [(ngModel)]="barcodeInputPathology" [ngModelOptions]="{standalone: true}" type="number"
                                *ngIf="scanning && pathologyScanning === path.AutoIndex"
                                (ngModelChange)="onBarcodeInputChange()"
                                (blur)="finishScan()"
                                (keyup.enter)="finishScan()" />
                                <br *ngIf="path.BarCode && ! path.Lab && ! scanning">
                            <button (click)="scanExistingPathology(path.AutoIndex)" class="btn" style="color: white; padding-left: 1em; padding-right: 1em; margin-left: 1em"
                                *ngIf="! path.Lab && ! scanning">Scan Code</button>
                        </div>
                        <div class="l-td-m">{{path.Comments}}</div>
                    </div>
                </ng-container>
            </div>
            <div *ngIf="labReports.length > 0">
                <h2>Lab Reports:</h2>  All Reports Received: <input type="checkbox" [(ngModel)]="allReportsReceived" [ngModelOptions]="{standalone: true}" (change)="allLabResultsReceived()"/>
                <div class="l-table-auto">
                    <div class="l-row weightAss-tbody">
                        <div class="l-td-m" style="width: 5%;"></div>
                        <div class="l-td-m" style="width: 5%;">#</div>
                        <div class="l-td-m" style="width: 10%;">Report</div>
                        <div class="l-td-m" style="width: 10%;">Lab Date</div>
                        <div class="l-td-m" style="width: 15%;color: #015a6c">Lab Findings</div>
                        <div class="l-td-m" style="width: 55%;">Physician's Comments</div>
                    </div>
                    <ng-container *ngFor="let item of labReports; index as i">
                        <div class="l-row weightAss-tbody">
                            <div class="l-td-m"></div>
                            <div class="l-td-m center">
                                <div>{{i+1}}</div>
                            </div>
                            <div class="l-td-m">
                                <img 
                                src="../../assets/icons/fileb.svg" 
                                style="vertical-align: auto;" 
                                width="50" height="50" alt="Lab Findings Icon" 
                                *ngIf="item.AutoIndex"
                                 matTooltip="Open Lab Report from {{item.Lab}}" (click)="showReport(item.AutoIndex)">
                            </div>
                            <div class="l-td-m">{{item.ReceptionDate | date:"dd.MM.yyyy"}}</div>
                            <div class="l-td-m">{{item.exception == 1 ? 'Abnormal findings': 'Normal'}}</div>
                            <div class="l-td-m">
                                {{item.Analyzed? item.DoctorNote : ''}}
                                {{item.Analyzed ? '(on ' + (item.Analyzed | date:"dd.MM.yyyy") + ')' : ''}}
                                <textarea style="margin-left: 0;top:0;width: 100%;min-height: 6em;" [(ngModel)]="labcomment[i]" [ngModelOptions]="{standalone: true}" *ngIf="! item.Analyzed" (ngModelChange)="saveComment(i, item.AutoIndex)" [disabled]="loginService.userType != 'doctor'"></textarea>
                                <button *ngIf="! item.Analyzed && loginService.userType === 'doctor'" class="btn" style="margin-top: 0.5em;" (click)="markAsReviewed(item.AutoIndex)">Mark As Reviewed</button>
                            </div>
                        </div>
                    </ng-container>
                </div>
            </div>
            <div *ngIf="otherInboxItems.length > 0 && notFromToday()">
                <h2>Inbox for this Patient:</h2>
                <ul> 
                    <li *ngFor="let item of otherInboxItems" (click)="showReport(item.AutoIndex, true)" style="cursor: pointer;">
                       Sampled On: {{item.SampleDate | date:"dd.MM.yyy"}}, Results From: {{ item.ReceptionDate  | date:"dd.MM.yyyy" }} - {{ item.Lab }}
                    </li>
                </ul>
            </div>
            <!--add a search from date to date by Lab for other missing reports in case they came in with the wrong pat ID-->
            <div *ngIf="loginService.premissions['GastroLabReports'] &&  notFromToday()">
                <h3>Search for unowned Lab Reports by Date</h3>
                <label>From:  <mat-datepicker #startDatepicker></mat-datepicker> 
                <input [(ngModel)]="searchFromDate" [ngModelOptions]="{standalone: true}" [matDatepicker]="startDatepicker" (click)="startDatepicker.open()" class="t-field t-field--date menstural-field"/></label>
                <label>To: <mat-datepicker #endDatepicker></mat-datepicker>
                <input [(ngModel)]="searchToDate" [ngModelOptions]="{standalone: true}" [matDatepicker]="endDatepicker" (click)="endDatepicker.open()" class="t-field t-field--date menstural-field"/></label>
                <button class="btn" (click)="searchMissingReports()">Search</button>
                <div *ngIf="unassignedInboxItems.length > 0">
                    <h4>Results:</h4>
                    <ul>
                        <li *ngFor="let item of unassignedInboxItems" (click)="showReport(item.AutoIndex, true)" style="cursor: pointer;">
                            Patient ID: {{ item.ID }} - Sampled: {{ item.SampleDate  | date:"dd.MM.yyyy" }} - {{ item.Lab }}
                        </li>
                    </ul>
                </div>
            </div>
        </section>
        <section *ngIf="es.ExamType=='Gastroscopy'" class="m-box" [formGroup]="gs.gastroForm" style="width: 100%;">
            <h2>Rapid Urease Test (H.pylori)</h2>
            <div style="display: flex;
                    flex-direction: row;
                    justify-content: space-between;">
                <div class="l-flex-c l-flex-w indicative-fieldset" style="flex-wrap: inherit;">
                    <label class="t-label-top">
        
                        <input type="radio" formControlName="Hp" value="positive" class="custom-check -sq" />
                        <i class="customInput-display -sq"></i>
                        <span>
                            Positive
                        </span>
        
                    </label>
        
                    <label class="t-label-top">
                        <input type="radio" formControlName="Hp" value="negative" class="custom-check -sq" />
                        <i class="customInput-display -sq"></i>
                        <span>
                            Negative
                        </span>
                    </label>
                </div>
                <section class="m-box" style="width: 50%;">
                    <h2>Comment</h2>
                    <textarea class="fulltext" style="margin-left: 0;top:0;width: 100%;min-height: 6em;"
                        formControlName="HpComment"></textarea>
                    <button class="t-btn-edit" *ngIf="! es.isClosed"
                        (click)="atS.showAuto(gs.gastroForm.get('HpComment'),'Rapid urease test (H.pylori) Comment',365)">Auto
                        Text</button>
                </section>
            </div>
        
        </section>
        <section class="m-box" [formGroup]="gs.gastroForm" style="width: 100%;">
            <h2>Comment</h2>
            <textarea class="fulltext" style="margin-left: 0;top:0;width: 100%;min-height: 6em;" formControlName="PathologyComments"></textarea>
            <button class="t-btn-edit" *ngIf="! es.isClosed"
            (click)="atS.showAuto(gs.gastroForm.get('PathologyComments'),'Pathology Comments',210)">Auto Text</button>
        </section>
    </div>
</div>
<app-labreport *ngIf="reportToShow" [reportid]="reportToShow" (closed)="reportClosed($event)" [assignable]="inbox"></app-labreport>
